import { evaluatePluginCondition, pluginConditionAllowed } from "./json-logic"

export type RegistrySubmitDeclaration = {
  id: string
  label: string
  command: string
  variant?: "primary" | "secondary" | "ghost"
  disabledWhen?: unknown
  disabledReason?: string
}

export type RegistrySubmitState = {
  error?: string
  result?: unknown
}

export type RegistryRuntime = {
  blockId: string
  pending: boolean
  readonly?: boolean
  submits: RegistrySubmitDeclaration[]
  submitState?: RegistrySubmitState
  context: Record<string, unknown>
  onSubmit: (values: Record<string, unknown>) => void | Promise<void>
}

export type RegistrySubmitDescriptor = RegistrySubmitDeclaration & {
  disabled: boolean
  disabledFor: (values?: Record<string, unknown>) => boolean
  pending: boolean
  error?: string
  result?: unknown
  run: (values: Record<string, unknown>) => void | Promise<void>
}

export function normalizeRegistrySubmits(runtime?: RegistryRuntime): RegistrySubmitDescriptor[] {
  if (!runtime) return []
  return runtime.submits.map((submit) => {
    const disabledFor = (values?: Record<string, unknown>) =>
      submit.disabledWhen === undefined
        ? false
        : !pluginConditionAllowed(submit.disabledWhen) ||
          evaluatePluginCondition(submit.disabledWhen, values ? { ...runtime.context, values } : runtime.context)
    return {
      ...submit,
      disabled: disabledFor(),
      disabledFor,
      pending: runtime.pending,
      error: runtime.submitState?.error,
      result: runtime.submitState?.result,
      run: (values) => {
        if (runtime.pending || disabledFor(values)) return
        return runtime.onSubmit({ ...values, command: submit.command })
      },
    }
  })
}

export function registrySubmitByCommand(submits: RegistrySubmitDescriptor[], command: string) {
  return submits.find((submit) => submit.command === command)
}
